import { set } from 'lodash'
import {Mutation} from './mutation-types'

export default {
    createOrderReference({commit}, orderReference) {
        return commit(Mutation.CREATE_ORDER_REFERENCE, lineaPedido)
    },
    createHistorical({commit}, estacion) {
        return commit(Mutation.CREATE_HISTORY, estacion)
    },
    // Payload : {ordeºrReferenceHistorical, stationHistoricals , machineHistoricals}
    createDecomposedHistorical({commit},  payload) {
        return commit(Mutation.CREATE_DECOMPOSED_HISTORY, payload)
    },
    createActiveModal({commit}, payload) {
        return commit(Mutation.CREATE_ACTIVE_MODAL, payload)
    },

    deleteActiveModal({commit}, payload) {
        return commit(Mutation.DELETE_ACTIVE_MODAL, payload)
    },
    changeActiveModalState({commit, state}, {modal, data}) {
        if(state.activeModals.findIndex(m => m.modal === modal) !== -1)
            return commit(Mutation.DELETE_ACTIVE_MODAL, {modal, data})
        else
            return commit(Mutation.CREATE_ACTIVE_MODAL, {modal, data})
    },
    // KANBAN
    createKanban({commit}, payload) {
        return commit(Mutation.CREATE_KANBAN, payload);
    },
    // KANBAN ORDER REFERENCES
    createKanbanOrderReference({commit}, payload) {
        return commit(Mutation.CREATE_KANBAN_ORDER_REFERENCE, payload)
    },
    updateKanbanOrderReference({commit}, payload) {
        return commit(Mutation.UPDATE_KANBAN_ORDER_REFERENCE, payload)
    },
    deleteKanbanOrderReference({commit}, payload) {
        return commit(Mutation.DELETE_KANBAN_ORDER_REFERENCE, payload)
    },
    orderKanbanOrderReferences({commit}, payload) {
        return commit(Mutation.ORDER_KANBAN_ORDER_REFERENCES, payload)
    },

    createKanbanPendingList({commit}, payload) {
        return commit(Mutation.CREATE_KANBAN_PENDING_LIST, payload)
    },

    // CALENDAR
    createCalendar({commit}, payload) {
        return commit(Mutation.CREATE_CALENDAR, payload);
    },
    createCalendarEvent({commit}, payload) {
        return commit(Mutation.CREATE_CALENDAR_EVENT, payload);
    },
    updateCalendarEvent({commit}, payload) {
        return commit(Mutation.UPDATE_CALENDAR_EVENT, payload);
    },
    deleteCalendarEvent({commit}, payload) {
        return commit(Mutation.DELETE_CALENDAR_EVENT, payload);
    },
    deleteOrderReferenceCalendarEvents({commit}, payload) {
        return commit(Mutation.DELETE_ORDER_REFERENCE_CALENDAR_EVENTS, payload);
    },
    deleteAllCalendarEvents({commit}, payload) {
        return commit(Mutation.DELETE_ALL_CALENDAR_EVENTS, payload)
    },
    addCalendarEvents({commit}, payload) {
        return commit(Mutation.ADD_CALENDAR_EVENTS, payload)
    },    

    // FILTROS
    updateFilter({commit}, payload){
        return commit(Mutation.UPDATE_FILTER, payload)
    },
    deleteFilter({commit}, payload){
        return commit(Mutation.DELETE_FILTER, payload)
    },

    //LAST UPDATE TIME

    setLastUpdateTime({commit}, payload) {
        return commit(Mutation.SET_LAST_UPDATE_TIME, payload)
    },
    setQueueEditActive({commit}, payload) {
        return commit(Mutation.SET_QUEUE_EDIT_ACTIVE, payload)
    },

    setShowKanbanContainerOverlay({commit}, payload) {
        return commit(Mutation.SET_SHOW_KANBAN_CONTAINER_OVERLAY, payload)
    },

    setIsMenuShowing({commit}, payload) {
        return commit(Mutation.SET_IS_MENU_SHOWING, payload)
    },
}
